import React,{useContext, useState} from 'react'

import { Outlet, Navigate } from 'react-router-dom'


import {UserContex} from '../App'

const ProtectedRoutesParticipant = () => {
    const {state, dispatch }= useContext(UserContex)


    const user = JSON.parse( localStorage.getItem("participant"))
    

    return(
        user ? <Outlet/> : <Navigate to="/login"/>);
}

export default ProtectedRoutesParticipant